import { render, staticRenderFns } from "./BalanceUpdate.vue?vue&type=template&id=23494651&scoped=true"
import script from "./BalanceUpdate.vue?vue&type=script&lang=js"
export * from "./BalanceUpdate.vue?vue&type=script&lang=js"
import style0 from "./BalanceUpdate.vue?vue&type=style&index=0&id=23494651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23494651",
  null
  
)

export default component.exports